<template>
	<div class="position-relative">
		<div class="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
			<div class="authentication-inner py-6">
				<!-- Register Card -->
				<div class="card p-md-7 p-1">
					<!-- Logo -->
					<div class="app-brand justify-content-center mt-5">
						<a href="javascript:void(0)" class="app-brand-link gap-2">
							<span class="app-brand-logo demo">
								<span style="color: var(--bs-primary)">
									<img :src="logoUrl" :style="logoSize()" alt="Logo">
								</span>
							</span>
						</a>
					</div>
					<!-- /Logo -->
					<div class="card-body mt-1">
						<p class="mb-5 text-center">Bienvenue chez {{ brandName }}</p>

						<form id="formAuthentication" @submit.prevent="loginUser" class="mb-5">
							<div class="form-floating form-floating-outline mb-5">
								<input type="text" class="form-control" id="email" name="email" placeholder="Votre email" v-model="form.email" @input="clearError('email')" />
								<label for="email">Email</label>
								<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
							</div>
							<div class="form-floating form-floating-outline mb-5">
								<input type="password" class="form-control" id="password" name="password" placeholder="Mot de passe" v-model="form.password" @input="clearError('password')" />
								<label for="password">Mot de passe</label>
								<small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
							</div>
							
							<button class="btn btn-primary d-grid w-100" type="submit">Connexion à votre compte</button>
						</form>

						<p class="text-center">
							<span>Vous n'avez pas de compte ? </span>
							<router-link to="/register">
								<span>Inscrivez vous</span>
							</router-link>
						</p>

						<p class="text-center">
							<span>Vous avez oublié </span>
							<router-link to="/forgot-password">
								<span>votre mot de passe?</span>
							</router-link>
						</p>
					</div>
				</div>
				<!-- Register Card -->
				<img
					alt="mask"
					src="@/assets/img/illustrations/auth-basic-register-mask-light.png"
					class="authentication-image d-none d-lg-block"
					data-app-light-img="illustrations/auth-basic-register-mask-light.png"
					data-app-dark-img="illustrations/auth-basic-register-mask-dark.png" />
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/vendor/css/pages/page-auth.css";

import HTTP from "@/axios";

export default {
	name: "LoginPage",

	data() {
		return {
			domain: null,
			form: {
				email: "",
				password: ""
			},
			errors: {},
		};
	},

	async mounted() {
		this.domain = window.location.hostname;
		this.form.email = this.$route.query.email;
	},

	computed: {
		logoUrl() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return require('@/assets/logo-2mtraining.png');
			} else {
				return require('@/assets/logo.png');
			}
		},

		brandName() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return "2MTraining";
			} else {
				return "Pika Aero";
			}
		}
	},

	methods: {
		logoSize() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return { width: "80px" };
			} else {
				return { width: "160px" };
			}
		},

		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			this.form.email = (this.form.email).trim();

			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = "Veuillez entrer une adresse e-mail valide.";
			}
			if (!this.form.password) {
				this.errors.password = "Veuillez entrer un mot de passe valide.";
			}
			
			return Object.keys(this.errors).length === 0;
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		async loginUser() {
			const validated = this.validateForm();

			if (!validated)
				return;

			try {
				const response = await HTTP.post('/auth/login', this.form);

				// Save JWT
				this.$store.dispatch("saveJwt", response.data.accessToken);

				// Setup company
				this.$router.push("/");
			} catch (error) {
				alert("Identifiants invalides.");
			}
		}
	}
};
</script>
